/**
 * @generated SignedSource<<a69148278e4760237e7ca7936da8fd98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
import { FragmentRefs } from "relay-runtime";
export type RewardsFragment$data = {
  readonly rewards: {
    readonly nodes: ReadonlyArray<{
      readonly description: string;
      readonly id: string;
      readonly kind: RewardKind;
    }>;
  };
  readonly " $fragmentType": "RewardsFragment";
};
export type RewardsFragment$key = {
  readonly " $data"?: RewardsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RewardsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RewardsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RewardConnection",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Reward",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Rewardable",
  "abstractKey": "__isRewardable"
};

(node as any).hash = "e36ca4d91abcd682bcaf4239c0c72b58";

export default node;
